import tw from 'twin.macro';
import React from 'react';
import { CJEvent } from '@teetsh/app/src/types/event';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';
import { Tag } from '@teetsh/app/src/components/Tag';
import AttachmentLink from 'components/Attachments/AttachmentLink';
import { Density } from 'containers/CahierJournal/useCJConfigurationDisplay';

interface Props {
  className?: string;
  defaultTitle: string;
  event: CJEvent;
  onChange?: (v: CJEvent) => void;
  density: Density;
}

export function Bilan(props: Props) {
  const {
    event: { title, flow, attachments },
    defaultTitle,
    density,
  } = props;
  return (
    <div css={[tw`px-4 py-2`, density === 'compact' && tw`pb-1`]}>
      <Tag tw="bg-black text-white mb-2">
        <h6 tw="my-0">{title !== '' ? title : defaultTitle}</h6>
      </Tag>
      {flow && (
        <div tw="break-words whitespace-pre-line">
          <HtmlViewer
            text={flow}
            onChange={v => {
              if (props.onChange) {
                props.onChange({ ...props.event, flow: v });
              }
            }}
          />
        </div>
      )}
      <div tw="mb-1">
        {(attachments || []).map(a => (
          <AttachmentLink attachment={a} preview key={a.label} />
        ))}
      </div>
    </div>
  );
}
